import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/axios';

export const fetchUsers = createAsyncThunk('users/fetch', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/users');
    return data.users || [];
  } catch (err) {
    return rejectWithValue(err.response?.data?.message || 'Erreur.');
  }
});

export const createUser = createAsyncThunk(
  'users/create',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await api.post('/users', payload);
      return { user: data.user, temporaryPassword: data.temporaryPassword };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur lors de la création.');
    }
  }
);

export const deleteUser = createAsyncThunk(
  'users/delete',
  async ({ id, password }, { rejectWithValue }) => {
    try {
      await api.delete(`/users/${id}`, { data: { password } });
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur lors de la suppression.');
    }
  }
);

const usersSlice = createSlice({
  name: 'users',
  initialState: {
    list: [],
    loading: false,
    error: null,
    lastCreated: null,
  },
  reducers: {
    clearLastCreated: (state) => {
      state.lastCreated = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading = false;
      })
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(createUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(createUser.fulfilled, (state, action) => {
        const newUser = { ...action.payload.user, postCount: 0 };
        state.list = [newUser, ...state.list];
        state.lastCreated = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(createUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.loading = false;
        state.list = state.list.filter((u) => u._id !== action.payload);
        state.error = null;
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearLastCreated, clearError } = usersSlice.actions;
export default usersSlice.reducer;
